<template>
  <div class="row">
    <div class="col">
      <div class="card card-small mb-4">
        <div class="card-header border-bottom">
          <div class="float-left">
            <h6 class="m-0">Campos</h6>
          </div>
          <div v-if="pagination.TotalItems > 0" class="float-right">
            <h6 class="m-0">
              {{ pagination.TotalItems | number }}
              {{ pagination.TotalItems > 1 ? " itens" : "item" }}
            </h6>
          </div>
        </div>
        <div class="card-body p-0 pb-3 text-center">
          <loader :is-loading="loadingList"></loader>
          <table class="table mb-0" v-if="!loadingList">
            <thead class="bg-s2p-gray-light">
              <tr>
                <th scope="col" class="border-0"></th>
                <th scope="col" class="border-0">Código</th>
                <th scope="col" class="border-0">Conta Contábil</th>
                <th scope="col" class="border-0 text-left">Nome</th>
                
                <th scope="col" class="border-0"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(field, index) in lines" :key="index">
                <td></td>
                <td>{{ field.Code }}</td>
                <td>{{ field.AccountCode }}</td>
                <td class="text-left">{{ field.Name }}</td>
                <td>
                  <div class="dropdown">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Opções
                    </button>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        v-if="$isAuthorize('AccountsPayableCategory', 'Get')"
                        class="dropdown-item"
                        href="#"
                        v-on:click="OpenField($event, index, true)"
                      >
                        <i class="fas fa-eye mr-2"></i> Visualizar
                      </a>
                      <a
                        v-if="$isAuthorize('AccountsPayableCategory', 'Update') && !field.IsExcluded"
                        class="dropdown-item"
                        href="#"
                        v-on:click="OpenField($event, index)"
                      >
                        <i class="fas fa-highlighter mr-2"></i> Editar
                      </a>
                      <a
                        v-if="$isAuthorize('AccountsPayableCategory', 'Delete') && !field.IsExcluded"
                        class="dropdown-item"
                        href="#"
                        v-on:click="
                          ConfirmDeleteAccountsPayableCategory(
                            field.Name,
                            field.Id
                          )
                        "
                      >
                        <i class="fas fa-trash-alt mr-2"></i> Remover
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
              <tr
                v-if="
                  lines == undefined || lines == null || lines.length == 0
                "
              >
                <td colspan="6">Sem registros</td>
              </tr>
            </tbody>
          </table>

          <div class="col-12 border-top">
            <div class="pagination-nav">
              <b-pagination
                class="float-right"
                v-model="pagination.PageNumber"
                :total-rows="pagination.TotalItems"
                :per-page="pagination.RowsPerPage"
                aria-controls="my-table"
              ></b-pagination>
              <div class="float-left">
                <d-select size="sm" v-model="pagination.RowsPerPage">
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                </d-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TableListAPC",
  props: {
    lines: {
      type: Array
    },
    pagination: {
      type: Object
    },
    loadingList:{
      type:Boolean
    }
  },
  watch: {
    pagination(){
      this.$emit('update:pagination', pagination);
    },
    "pagination.PageNumber"() {
      this.$emit("List");
    },
    "pagination.RowsPerPage"() {
      this.$emit("List");
    }
  },
  methods: {
    OpenField(e, i, view) {
      this.$emit("Open", e, i, view);
    },
    ConfirmDeleteAccountsPayableCategory(Name, Id) {
      this.$emit("ConfirmDelete", Name, Id);
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/sub-components/AccountsPayableCategory/TableListAPC.vue